
import { useParams } from 'react-router-dom'
import { ListKeys, getApplicationList } from '../../../api/list'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'
import { getLocalStorageItem } from '../../../utils/storageHelper'
import { createModule, getModulebyId, updateModule } from './apiCall'
import { ModulesKeys } from './entity'

function ModuleEdit() {
  let { id, mode } = useParams();

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TextInput,
      name: 'Name',
      label: 'Name',
      value: null,
      required: true,
      maxLength: 100,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'DisplayName',
      label: 'Display Name',
      value: null,
      required: true,
      maxLength: 100,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'Routes',
      label: 'Routes',
      value: null,
      required: true,
      valueTypes: ValueTypes.urlPath
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'ApplicationId',
      label: 'Application',
      value: getLocalStorageItem('ApplicationId'),
      displayExpr: "DisplayName",
      valueExpr: "ApplicationId",
      getListData: getApplicationList,
      apiKey: ListKeys.applications,
      required: true,
      disabled: true
    },
    {
      type: FormItemTypes.TextInput,
      name: 'LogoPath',
      label: 'Logo Path',
      value: null,
      required: true,
      valueTypes: ValueTypes.urlPath
    },
    {
      type: FormItemTypes.NumberInput,
      name: 'Sequence',
      label: 'Sequence',
      value: null,
      required: true,
      valueTypes: ValueTypes.number,
      maxLength: 3
    },
    {
      type: FormItemTypes.TextInput,
      name: 'Description',
      label: 'Description',
      value: null,
      multiline: true,
      rows: 4,
      maxLength: 400,
      md: 6
    },
  ]

  return (
    <FormBuilderContainer
      formData={formData}
      mode={mode || (id ? 'edit' : 'add')}

      getFormAPI={getModulebyId}
      getRequest={{ id: id }}
      getKey={ModulesKeys.get}

      createFormAPI={createModule}
      createKey={ModulesKeys.create}

      updateFormAPI={updateModule}
      updateKey={ModulesKeys.update}

      headerLabel={mode === 'add' ? 'Add Module' : 'Module'}
      parentPath='/modules'
    />
  )
}

export default ModuleEdit